import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-07-03 12:47:34
 * @LastEditTime: 2022-08-15 15:04:06
 * @FilePath: /insurforce-backstage-platform-side/src/views/examine/claimRecordManage/request.js
 */
import request from '@/utils/request2';
export function claimsRecordNewList(data) {
  return request.post('admin/claims-management/record', data);
}
export function claimsDetail(data, type, type2) {
  console.log(data, type);
  let url = type == 2 ? 'admin/audit/claims-review/render' : 'admin/audit/claims-review/detail';
  return request.post(url, data).then(res => {
    if (!type2) {
      res.claimsInfo.claimsSort.map(i2 => {
        i2.auditOpinion2 = i2.auditOpinion;
        i2.auditOpinion = '';
        return i2;
      });
    }
    res.claimsInfo.claimsDocument.map(i2 => {
      if (!type2) {
        i2.auditOpinion2 = i2.auditOpinion;
        i2.auditOpinion = '';
      }
      i2.documentUrl.map((i, index) => {
        i.status = 'done';
        i.uid = index + 1;
        return i;
      });
      return i2;
    });
    return res;
  });
}
//下载zip
export function reviewZip(data) {
  return request.post('admin/audit/claims-review/zip', data);
}
//审核
export function claimsApprove(data) {
  data.isMailing = data.isMailing || 0;
  console.log(data, JSON.parse(data.claimsContent));
  return request.post('admin/audit/claims-review/approve', data);
}
// 审核进度
export function auditSchedule(data) {
  return request.post('admin/audit/schedule', data);
}
// 审核详情
export function auditDetail(data) {
  return request.post('admin/audit/detail', data).then(res => {
    console.log(res.initialNodeInfo.claimsDocument);
    if (res.initialNodeInfo.claimsTypeId) {
      res.initialNodeInfo.claimsDocument.map(i2 => {
        console.log(i2.documentUrl);
        let arr = [];
        i2.documentUrl.map((i, index) => {
          let name = i.substring(i.lastIndexOf('/') + 1, i.lastIndexOf('.'));
          let format = i.substring(i.lastIndexOf('.')).toLowerCase();
          let obj = {
            status: 'done',
            uid: index + 1,
            url: i,
            format: format.slice(1),
            name: name + format
          };
          console.log(obj);
          arr.push(obj);
        });
        i2.documentUrl = arr;
        return i2;
      });
    }
    return res;
  });
}
// 审核操作
export function auditOperate(data) {
  return request.post('admin/audit/operate', data);
}
export function getTags(data) {
  return request.post('admin/claims-management/getTags', data);
}
export function claimsCustomer(data) {
  return request.post('admin/claims-management/customer', data);
}